export default __webpack_public_path__ + "static/media/back-arrow.3b71d1dc.svg";